import http from '../../../http'
import { getQuery } from '../../../lib/xes/xes-lib'

/* 
 * 打点1.0
 * @param {Object} res
 * @param {String} logytype
 * @return {Promise}
 */
const sendClassWorkCheckLog = (res, logtype='classwork_check_click') => {
  let errType = 'success'
  if (res.data.result === 'fail') {
    errType = 'fail'
  }
  return http.sendLog({
    ...{
        user_id: getQuery('stuId'),
        template_project_id: getQuery('template_project_id'),
        err_type: errType
      },
    ...{
        eventid: 'classwork',
        biz: 'live',
        logtype: logtype,
        lang: 'scratch',
        user_agent: '打点1.0'
      }
    })
}
/* 
 * 打点2.0
 */
const sendClassWorkSmartLog = (err_type, trigger_type, duration, isEmpty) => {
    // return http.sendLog({
    //     ...{
    //         stuId: getQuery("stuId"),
    //         liveId: getQuery("liveId"),
    //         template_project_id: getQuery("template_project_id"),
    //         err_type: err_type,
    //         trigger_type: trigger_type,
    //         duration: Math.round(duration),
    //         is_empty: isEmpty
    //     },
    //     ...{
    //         eventid: "classwork",
    //         biz: "live",
    //         logtype: "intelligent_prompt_trigger",
    //         lang: "scratch",
    //         user_agent: '打点2.0'
    //     }
    // });
};

let commonData = null
setTimeout(()=>{
    commonData = {
        eventid: "classwork",                                   // 事件ID
        biz: "live",                                            // 业务
        stuId: getQuery("stuId"),                               // 用户ID
        template_project_id: getQuery("template_project_id"),   // 题目ID
        liveId: getQuery("liveId"),                             // 场次ID
        lang: "scratch"                                         // 语言
    }
})
/*
 * 打点3.0 触发智能提示
 * @param {String} err_type 错误类型
 * @param {String} trigger_type 触发类型
 * @param {String} duration 触发时间
 * @param {Number} is_empty 是否为空白提交 [0,1]
 * @return {Promise}
 */
const sendIntelligentPromptTrigger = (err_type,trigger_type,duration,is_empty)=>{
    return http.sendLog({
        err_type,                               // 错误类型
        trigger_type,                           // 触发时机
        duration,                               // 答题时长
        is_empty,                               // 是否空白
        logtype: "intelligent_prompt_trigger",  // 日志类型
        ...commonData
    })
}
/*
 * 打点3.0 查看智能提示
 * @param {String} trigger_type 触发类型
 * @param {String} err_type 错误类型
 * @return {Promise}
 */
const sendIntelligentPromptView = (trigger_type,err_type)=>{
    return http.sendLog({
        logtype: "intelligent_prompt_view",
        ...commonData,
        trigger_type,
        err_type
    })
}
/*
 * 打点3.0 触发附加题
 * @param {String} trigger_type 触发类型
 * @param {String} err_type 错误类型
 * @return {Promise}
 */
const extendworkTrigger = (trigger_type,duration)=>{
    return http.sendLog({
        logtype: "extendwork_trigger",
        ...commonData,
        trigger_type,
        duration
    })
}
export {
    sendClassWorkCheckLog,
    sendClassWorkSmartLog,

    sendIntelligentPromptTrigger,
    sendIntelligentPromptView,
    extendworkTrigger
};